module.exports = __webpack_public_path__ + "img/greenn_club.31268d2a.png";